<template>
  <div class="hello container">
    <div class="container mt-3">
      <h3>Edición de correos electrónicos</h3>
      <h6>
        Tener en cuenta que los mensajes se componen con información que varía
        dependiendo del beneficio correspondiente.
      </h6>
      <div class="row">
        <!-- Asunto -->
        <div class="col-12 col-sm-6  mx-auto">
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              placeholder="Asunto"
              aria-label="Ingrese aquí"
              aria-describedby="basic-addon1"
              maxlength="40"
              v-model="mensaje.asunto"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <!-- Cuerpo del mensaje -->
        <div class="col-12 col-sm-6  mx-auto ">
          <div class="input-group mb-3">
            <textarea v-model="mensaje.cuerpo" class="form-control" placeholder="Cuerpo del mensaje"></textarea>            
          </div>
        </div>
      </div>
      <div class="row boton">
        <!-- btn Guardar -->
        <div class="col-12 col-sm-6  mx-auto">
          <button class="btn btn-success" @click="guardarMensaje(mensaje)">
            Guardar
          </button>
        </div>
        <!-- btn Cancelar -->
        <div class="col-12 col-sm-6 mx-auto">
          <button class="btn btn-success" @click="cancelar()">
            Cancelar/Limpiar
          </button>
        </div>
      </div>
    </div>

    <div class="container mt-4 container-tabla">
      <h3>Mensajes actuales</h3>
      <table class="table table-hover">
        <thead>
          <tr>
            <th v-for="col in columnas" v-bind:key="col" scope="col">
              {{ col }}
            </th>
          </tr>
        </thead>
        <tbody class="tabla">
          <tr
            v-for="mensaje in mensajes"
            v-bind:key="mensaje.id"
            class="overflow-auto"
          >
            <td>{{ mensaje.nombre }}</td>
            <td>{{ mensaje.asunto }}</td>
            <td>
              <p>{{ mensaje.cuerpo }}</p>
            </td>

            <td>
              <button
                type="button"
                class="btn btn-danger"
                @click="editar(mensaje)"
              >
                <font-awesome-icon :icon="Icons.EDITAR" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Swal from "sweetalert2";

import { Api } from "../../api";
import { environment } from "../../environments/environment";
import { Icons as IconConstants } from "../../constants";

export default {
  components: { FontAwesomeIcon },
  computed: {
    cestoBasura() {
      return faTrash;
    },
    Icons() {
      return IconConstants;
    },
  },
  data() {
    return {
      columnas: ["Tipo de mensaje", "Asunto", "Cuerpo", "Editar"],

      mensajes: [],
      token: "",
      mensaje: "",
    };
  },
  methods: {
    editar(mensaje) {
      this.mensaje = mensaje;
    },
    cancelar() {
      this.mensaje = {};
      axios.get(environment.API_URL + "mensaje").then((response) => {
        this.mensajes = response.data;
      });
    },
    guardarMensaje(mensaje) {
      if (mensaje.id) {
        Api.Mensaje.guardar(mensaje, this.token).then(() => {
          this.mensaje = {};
          axios.get(environment.API_URL + "mensaje").then((response) => {
            this.mensajes = response.data;
          });
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Problemas",
          text: "Debe seleccionar algún correo para editar!",
        });
      }
    },
  },
  mounted() {
    this.token = localStorage.getItem("token");
    axios.get(environment.API_URL + "mensaje").then((response) => {
      this.mensajes = response.data;
    });
  },
};
</script>

<style scoped>
.boton {
  display: inline-flex;
  margin: 0;
  padding: 0;
}

.boton div button {
  width: 150px;
}

.tabla tr td:nth-child(3) {
  width: 50vw;
}

.tabla tr td p {
  width: 47vw;
  /* overflow-x: scroll; */
  overflow-y: hidden;
  /* text-overflow: ellipsis; */
  /* overflow: hidden;;*/
  white-space: nowrap;
  position: absolute;
}

/* ************************************************************************ */
/* ******************* Media Queries ************************************** */
/* ************************************************************************ */

/* Small devices (landscape phones, 576px and up) */
@media (max-width: 576px) {
  .container-tabla{
    padding-left: 0;
    padding-right: 0;
  }

  .table td{
    padding: 0.15rem;
    border: 1px solid gray;
  }

  .boton div button {
    display: inline;
    margin: 10px 0 10px 0;
    padding: 10px 0 10px 0;
  }

  .tabla tr td:nth-child(3) {
    width: 50vw;
  }

  .tabla tr td p {
    width: auto;
    overflow-x: hidden;
    overflow-y: scroll;
    white-space: normal;
    position: relative;
    height: 25vw;
  }
}

/* Small devices (landscape phones, less than 768px) */
@media screen and (min-width: 577px) and (max-width: 766px) {
  .tabla tr td:nth-child(3) {
    width: 43vw;
  }

  .tabla tr td p {
    width: 25vw;
  }
}

/* Medium devices (tablets, less than 992px) */
@media screen and (min-width: 767px) and (max-width: 991px) {
  .tabla tr td:nth-child(3) {
    width: 43vw;
  }

  .tabla tr td p {
    width: 40vw;
  }
}

/* Large devices (desktops, less than 1250px) */
@media (min-width: 1250px) {
  .tabla tr td:nth-child(3) {
    width: 630px;
  }

  .tabla tr td p {
    width: 610px;
  }
}
</style>
